// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WlGBY","title":"styles_title__fqL58","tabs":"styles_tabs__1Ax1O","tabItem":"styles_tabItem__vUIf7","active":"styles_active__7qmDm"};